export default "__VITE_ASSET__CQ84zDXE__"